'use strict';

require('jquery');

require('object-fit-images');

require('./autoload/_bootstrap.js');

var _Router = require('./util/Router');

var _Router2 = _interopRequireDefault(_Router);

var _common = require('./routes/common');

var _common2 = _interopRequireDefault(_common);

var _home = require('./routes/home');

var _home2 = _interopRequireDefault(_home);

var _about = require('./routes/about');

var _about2 = _interopRequireDefault(_about);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Populate Router instance with DOM routes */

// import local dependencies
var routes = new _Router2.default({
  // All pages
  common: _common2.default,
  // Home page
  home: _home2.default,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs: _about2.default
});

// Load Events


// Import everything from autoload
// import external dependencies
jQuery(document).ready(function () {
  return routes.loadEvents();
});

jQuery(document).ready(function ($) {
  var gridBreakpoints = { xxl: 1440 };
  var $navbar = $('.navbar');

  /**
   * Handle page scroll.
   */
  $(window).scroll(function () {
    $navbar.toggleClass('is-scrolling', $(window).scrollTop() > 0);
  });

  $('.navbar-toggler').on('click', function (event) {
    if (window.innerWidth >= gridBreakpoints.xxl) {
      event.preventDefault();
      event.stopPropagation();
    }
    var $self = $(this);
    $navbar.toggleClass('is-open');
    setTimeout(function () {
      $self.toggleClass('close');
    }, 50);
  });
});


// WEBPACK FOOTER //
// ./scripts/main.js